
import { reactive } from "vue";
import { Options, Vue } from "vue-class-component";
import LayoutService from "../../../services/layout.service";
import { IGalleria } from "@/model/IGalleria.model";
@Options({
  props: ["loading"]
})
export default class IziLayout extends Vue {
  loading!: boolean;
  visibleLeft = false;
  visibleRight = false;
  galleria = reactive<IGalleria>({
    visible: false,
    value: []
  });
  created() {
    LayoutService.getSidebarLeftState.subscribe(
      state => (this.visibleLeft = state)
    );
    LayoutService.getSidebarRightState.subscribe(
      state => (this.visibleRight = state)
    );
    LayoutService.getGalleria.subscribe((galleria: IGalleria) => {
      this.galleria.visible = galleria.visible;
      this.galleria.value = galleria.value;
    });
  }
}
